<template>
    <form @submit.prevent="login" class="popup__form form-sms" :class="{'disabled-buttons':loading}">
        <div class="h3 form-sms__title">{{ trans('auth.code_sent') }}</div>
        <div class="form-sms__description">
            {{ trans('auth.on_your_number') }} {{ phoneHidden }} (<a href="#" @click.prevent="change">{{ trans('auth.change_number') }}</a>) {{ trans('auth.code_pass_sent_for_login') }}.
        </div>
        <div class="form-sms__fieldset text-center">
            <div class="form-sms__line">
                <label class="form-sms__input-label code-label" :class="loginError.status">
                    <span>{{ trans('auth.four_numbers_from_sms') }}</span>
                    <div class="code">
                        <CodeInput :autoFocus="true" type="number" :loading="false" :fields="4" :fieldWidth="40" :fieldHeight="48" class="input" v-on:change="onChange" v-on:complete="onComplete" />
                    </div>
                    <input-notification :data="loginError" />
                </label>
            </div>
            <div class="form-sms__line" v-if="time > 0">
                <div class="form-sms__description">
                    {{ trans('auth.will_expire_in') }} {{ time }} {{ trans('auth.seconds') }}
                </div>
            </div>
            <div class="form-sms__line">
                <button @click.prevent="send" class="btn btn-link">
                    {{ trans('auth.sent_code_again') }}
                </button>
            </div>
        </div>
        <button type="submit" class="form-sms__button button btn">
            {{ trans('auth.confirm_entry') }}
        </button>
    </form>
</template>

<script>
import CodeInput from "vue-verification-code-input";
import axios from "axios";
import inputNotification from "./../inc/InputNotification";

export default {
    components: {
        CodeInput,
        "input-notification": inputNotification
    },
    props: {
        time: {
            required: true
        },
        phone: {
            required: true
        }
    },
    data() {
        return {
            code: null,
            loginError: {
                status: null,
                message: null
            },
            loading: false
        }
    },
    mounted() {
        
    },
    computed: {
        phoneHidden() {
            let phone = this.phone;
            if (phone) {
                phone = phone.substring(0,6) + '*****' + phone.substring(11, phone.length);
            }
            return phone;
        },
    },
    methods: {
        onChange(code) {
            this.code = code;
            // console.log("onChange ", code);
        },
        onComplete(code) {
            this.code = code;
            // console.log("onComplete ", code);
        },
        login() {
            if (this.phone && this.code) {
                // Make request
                this.loading = true;
                axios({
                    method: "post",
                    url: window.globalVariables.locale + "/login/by_sms/login",
                    data: {
                        phone: this.phone,
                        code: this.code,
                    }
                })
                .then(response => {
                    // console.log(response);
                    switch (response.data.status) {
                        case "success":
                            this.loginError = {
                                status: 'success',
                                message: this.trans('auth.login_completed')
                            };
                            document.getElementsByTagName('html')[0].classList.remove('popup-show');
                            this.$emit("set", response.data);
                            break;
                        default:
                            this.loginError = {
                                status: 'error',
                                message: this.trans('auth.error_try_again')
                            };
                            break;
                    }
                    
                })
                .catch(error => {
                    this.loginError = {
                        status: 'error',
                        message: this.trans('auth.error_try_again')
                    };
                    // console.log(error);
                })
                .then(() => {
                    this.loading = false;
                })
            }
        },
        send() {
            this.$emit("send");
        },
        change() {
            this.$emit("change");
        }
    }
}
</script>